import { render, staticRenderFns } from "./AssetsSummary.vue?vue&type=template&id=1c35948d&"
import script from "./AssetsSummary.vue?vue&type=script&lang=js&"
export * from "./AssetsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports